import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'vw-climate-banner',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './climate-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './climate-banner.component.scss'
})
export class ClimateBannerComponent {
  @Input() selectedClimateType: string | null = null;
  @Input() myClimateType: string | null = null;
  @Output() pickerClick = new EventEmitter<void>();
}
